import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import categoryDataAccess, { CategoryListItem } from "src/dataAccess/category/category.dataAccess";
import { IListType } from "../store";

export const getCategoryListSuccess = createAction<{ data: CategoryListItem[]; dataCount: number }>(
  "[Category] Get Category List Success"
);
export const LoadingData = createAction<boolean>("[Category] Loading data");
export const loadingList = createAction<boolean>("[Category] Loading list");

export const getCategoryListAsync = createAsyncThunk<{ data: CategoryListItem[]; dataCount: number }, IListType>(
  "[Category] Get Category List",
  async (parameter, thunkAPI) => {
    thunkAPI.dispatch(loadingList(true));
    const result = await categoryDataAccess
      .getCategoryList(parameter)
      .then((res) => {
        thunkAPI.dispatch(getCategoryListSuccess(res));
        thunkAPI.dispatch(loadingList(false));
        return res;
      });
    return result;
  }
);

export const saveCategoryListSuccess = createAction<CategoryListItem[]>(
  "[Category] Save Category Success"
);

export const saveCategoryListAsync = createAsyncThunk<
  CategoryListItem,
  { categoryId: any; data: CategoryListItem; categoryList: Array<CategoryListItem> }
>("[Category] Save Category", async (parameter, thunkAPI) => {
  const { categoryId, data, categoryList } = parameter;
  thunkAPI.dispatch(loadingList(true));
  let updatedCategoryList: CategoryListItem[];
  if (categoryId === "edit") {
    let copyCategoryList = [...categoryList];
    updatedCategoryList = (copyCategoryList ?? []).map((item) => {
      let copyItem = { ...item };
      if (copyItem.id === data.id) {
        copyItem = data;
      }
      return copyItem;
    });
  } else {
    let copyCategoryList = [...categoryList];
    updatedCategoryList = [...copyCategoryList, data];
  }
  thunkAPI.dispatch(saveCategoryListSuccess(updatedCategoryList));
  thunkAPI.dispatch(loadingList(false));
  return data;
});

export const deleteCategorySuccess = createAction<string>("[Category] Delete Category Success");

export const deleteCategoryAsync = createAsyncThunk<
  { success: boolean; message: string; id: string },
  string
>(
  "[Category] Delete Category",
  async (id, thunkAPI) => {
    const res = await categoryDataAccess.deleteCategoryInfo(id);
    return { ...res, id };
  }
);

export const deleteCategoriesBulkAsync = createAsyncThunk<
  { success: boolean; message: string; failedIds?: (number | string)[]; ids: (number | string)[] },
  (number | string)[],
  { rejectValue: { message: string; failedIds?: (number | string)[]; ids: (number | string)[] } }
>(
  "[Category] Bulk Delete Category",
  async (ids, thunkAPI) => {
    const res = await categoryDataAccess.deleteCategoriesBulk(ids);

    if (!res.success) {
      return thunkAPI.rejectWithValue({ ...res, ids });
    }

    return { ...res, ids };
  }
);
